export const translations = {
 en: {
 seo: {
 title: "Family Office Setup for HNWIs | SFO & MFO Advisory, Aurelius Family Office",
 description: "Aurelius Family Office helps high-net-worth families set up single and multi-family offices in Dubai DIFC, Switzerland, Singapore, London and the US.",
 },
 nav: {
 links: [
 { id: "services", label: "Services" },
 { id: "jurisdictions", label: "Jurisdictions" },
 { id: "process", label: "Process" },
 { id: "insights", label: "Insights" },
        { id: "contact", label: "Contact" },
 ],
 cta: "Private Consultation",
 },
 hero: {
 overline: "Family Office Setup · DIFC · Switzerland · Singapore",
 title1: "Legacy,",
 title2: "Engineered.",
 sub: "We establish single and multi-family offices for high-net-worth families, from DIFC licensing to Swiss governance charters. Structure, succession and stewardship, designed to endure generations.",
 ctaPrimary: "Begin Your Structure",
 ctaSecondary: "Explore Services",
 stats: [
 ["$4.2B+", "Assets structured"],
 ["60+", "Families served globally"],
 ["5", "Regulated jurisdictions"],
 ],
 },
 marquee: [
 "Preserving Wealth",
 "Single Family Office Setup",
 "Multi-Family Office Advisory",
 "Global Wealth Structuring",
 "DIFC & Swiss Regulated",
 "Succession Planning",
 "Family Governance",
 ],
 services: {
 overline: "What We Build",
 title1: "Family office services",
 title2: "for HNW & UHNW families",
 desc: "Whether you are weighing a single family office against a multi-family office, or restructuring an existing one, we architect the entity, the governance and the team around your family's mandate.",
 items: [
 { title: "Single Family Office Setup", desc: "End-to-end SFO establishment for families with $50M+ in investable assets, entity formation, licensing, staffing and investment policy design in your chosen jurisdiction." },
 { title: "Multi-Family Office Advisory", desc: "Cost-efficient MFO access for HNWIs seeking institutional-grade management without the $1M+ annual overhead of a dedicated office." },
 { title: "Family Governance", desc: "Family constitutions, investment committees and decision frameworks that keep three generations aligned." },
 { title: "Succession Planning", desc: "Cross-border estate structuring, trusts and foundations engineered for seamless intergenerational transfer." },
 { title: "Wealth Structuring", desc: "Tax-efficient holding structures across DIFC, Swiss and Singapore regimes, fully compliant, fully private." },
 { title: "Risk & Compliance", desc: "Regulatory filings, CMS licensing, cybersecurity audits and ongoing compliance for operating family offices." },
 ],
 },
 jurisdictions: {
 overline: "Where We Operate",
 title1: "Four jurisdictions.",
 title2: "One standard of discretion.",
 guideLabel: "Read the full guide",
 items: [
 { name: "Dubai · DIFC", points: ["0% personal income tax", "DIFC Family Arrangements Regulations", "Setup in 8-12 weeks"] },
 { name: "Switzerland", points: ["Political & monetary stability", "Discreet private banking heritage", "Multi-generational trust law"] },
 { name: "Singapore", points: ["MAS SFO exemptions (13O/13U)", "Gateway to Asian markets", "CMS licensing for MFOs"] },
 { name: "United Kingdom", points: ["Deep capital markets access", "Established fiduciary frameworks", "World-class advisory talent"] },
 ],
 },
 process: {
 overline: "The Process",
 title: "From mandate to operating office in 2-6 months",
 desc: "A disciplined, milestone-driven path. You always know what happens next, who is accountable, and what it costs.",
 steps: [
 { n: "01", title: "Discovery & Mandate", desc: "Confidential assessment of assets, family objectives and the SFO vs MFO decision. Typically 2 weeks.", time: "Weeks 1-2" },
 { n: "02", title: "Structure & Jurisdiction", desc: "Entity design, jurisdiction selection and tax modelling across DIFC, Swiss, Singapore or dual-hub structures.", time: "Weeks 3-6" },
 { n: "03", title: "Licensing & Formation", desc: "Regulatory filings, DIFC family office licensing or MAS notifications, banking relationships and custody setup.", time: "Weeks 7-16" },
 { n: "04", title: "Governance & Handover", desc: "Family constitution, investment policy statement, key hires and operational handover to your office.", time: "Weeks 17-24" },
 ],
 },
 faq: {
 overline: "Insights",
 title: "Questions HNW families ask us",
 items: [
 { q: "How much does it cost to set up a family office?", a: "Costs vary by jurisdiction and structure. A DIFC family office involves roughly $8,000 in application fees and $12,000 in annual licensing, plus legal, tax and corporate service fees. A fully staffed single family office typically costs $1M+ per year to operate, which is why families below $50M-$250M in investable assets often choose a multi-family office instead." },
 { q: "What is the difference between a single family office and a multi-family office?", a: "A single family office (SFO) serves one family exclusively, full control, dedicated staff, complete privacy, but higher cost. A multi-family office (MFO) pools infrastructure across several families, delivering institutional expertise at a fraction of the cost. In Singapore, SFOs are generally exempt from CMS licensing while MFOs require it; in DIFC both require specific licensing." },
 { q: "How much wealth do I need to justify a single family office?", a: "Most advisors set the threshold at $50M-$250M in investable assets. Below that, the fixed costs of staff, compliance and infrastructure usually outweigh the benefits, and an MFO or virtual family office is more efficient." },
 { q: "Why set up a family office in Dubai (DIFC)?", a: "DIFC offers 0% personal income tax, a common-law framework, the dedicated Family Arrangements Regulations, and proximity to GCC wealth. Setup typically completes in 8-12 weeks, making it one of the fastest premium jurisdictions for HNWI families." },
 { q: "How long does the family office setup process take?", a: "Typically 2-6 months end-to-end: discovery and mandate (2 weeks), structuring and jurisdiction selection (4 weeks), licensing and formation (6-10 weeks), then governance and operational handover." },
 { q: "Do you help with succession planning and family governance?", a: "Yes. We draft family constitutions, establish trusts and foundations, design investment committees and create succession frameworks so wealth and decision-making transfer smoothly across generations." },
 ],
 },
 form: {
 overline: "Private Consultation",
 title: "Begin the conversation.",
 desc: "Every engagement begins with a confidential, no-obligation conversation with a senior partner. We respond within 24 hours, and everything you share is protected by strict confidentiality.",
 email: "enquiries@aureliusfamilyoffice.com",
 phone: "+971 4 000 0000 · +41 44 000 0000",
 steps: ["Your Mandate", "About You", "Objectives"],
 labels: {
 service: "Service of interest *",
 jurisdiction: "Jurisdiction of interest *",
 networth: "Investable assets *",
 name: "Full name *",
 email: "Email address *",
 phone: "Phone (optional)",
 company: "Family entity / company (optional)",
 contactTime: "Preferred contact time (optional)",
 message: "Tell us briefly about your objectives (optional)",
 },
 options: {
 services: [
 { v: "Single Family Office Setup", l: "Single Family Office Setup" },
 { v: "Multi-Family Office Advisory", l: "Multi-Family Office Advisory" },
 { v: "Family Governance", l: "Family Governance" },
 { v: "Succession Planning", l: "Succession Planning" },
 { v: "Wealth Structuring", l: "Wealth Structuring" },
 { v: "Undecided", l: "Undecided, advise me" },
 ],
 jurisdictions: [
 { v: "Dubai (DIFC)", l: "Dubai (DIFC)" },
 { v: "Switzerland", l: "Switzerland" },
 { v: "Singapore", l: "Singapore" },
 { v: "London", l: "London" },
 { v: "United States", l: "United States" },
 { v: "Undecided", l: "Undecided, advise me" },
 ],
 networth: [
 { v: "$10M, $50M", l: "$10M, $50M" },
 { v: "$50M, $250M", l: "$50M, $250M" },
 { v: "$250M+", l: "$250M+" },
 { v: "Prefer not to say", l: "Prefer not to say" },
 ],
 contactTimes: [
 { v: "Morning", l: "Morning" },
 { v: "Afternoon", l: "Afternoon" },
 { v: "Evening", l: "Evening" },
 ],
 },
 reviewTitle: "Your request",
 next: "Continue",
 back: "Back",
 submit: "Request Private Consultation",
 submitting: "Submitting...",
 success: "Request received. A senior partner will contact you within 24 hours.",
 error: "Something went wrong. Please try again.",
 validation: "Please complete all required fields.",
 invalidEmail: "Please enter a valid email address.",
 },
 footer: {
 about: "Family office setup and advisory for high-net-worth families across Dubai (DIFC), Switzerland, Singapore, London and the United States.",
 offices: "Offices",
 officesList: ["DIFC, Gate Village, Dubai", "Bahnhofstrasse, Zürich", "Raffles Place, Singapore"],
 contact: "Contact",
 guides: "Jurisdiction Guides",
 guidesList: [
 { slug: "family-office-dubai-difc", label: "Family Office in Dubai (DIFC)" },
 { slug: "family-office-switzerland", label: "Family Office in Switzerland" },
 { slug: "family-office-singapore", label: "Family Office in Singapore" },
 { slug: "family-office-london", label: "Family Office in London" },
 { slug: "family-office-usa", label: "Family Office in the US" },
 ],
 disclaimer: "Aurelius Family Office is a fictional demonstration brand. Nothing on this page constitutes financial, legal or tax advice.",
 },
 },
 ar: {
 seo: {
 title: "تأسيس المكاتب العائلية لأصحاب الثروات | أوريليوس فاميلي أوفيس",
 description: "أوريليوس فاميلي أوفيس تساعد العائلات ذات الثروات الكبيرة على تأسيس المكاتب العائلية الفردية والمتعددة في مركز دبي المالي العالمي وسويسرا وسنغافورة ولندن والولايات المتحدة.",
 },
 nav: {
 links: [
 { id: "services", label: "الخدمات" },
 { id: "jurisdictions", label: "الولايات القضائية" },
 { id: "process", label: "منهجية العمل" },
 { id: "insights", label: "رؤى ومعارف" },
        { id: "contact", label: "تواصل معنا" },
 ],
 cta: "استشارة خاصة",
 },
 hero: {
 overline: "تأسيس المكاتب العائلية · مركز دبي المالي العالمي · سويسرا · سنغافورة",
 title1: "إرثٌ،",
 title2: "يُهندَس ليدوم.",
 sub: "نؤسس المكاتب العائلية الفردية والمتعددة للعائلات ذات الثروات الكبيرة, من الترخيص في مركز دبي المالي العالمي إلى مواثيق الحوكمة السويسرية. هيكلة وتعاقب وإشراف، صُممت لتدوم عبر الأجيال.",
 ctaPrimary: "ابدأ هيكلة مكتبك",
 ctaSecondary: "استكشف الخدمات",
 stats: [
 ["+4.2 مليار دولار", "أصول تمت هيكلتها"],
 ["+60", "عائلة حول العالم"],
 ["5", "ولايات قضائية منظمة"],
 ],
 },
 marquee: [
 "الحفاظ على الثروة",
 "تأسيس المكتب العائلي الفردي",
 "استشارات المكاتب العائلية المتعددة",
 "الهيكلة العالمية للثروات",
 "مرخصون في DIFC وسويسرا",
 "تخطيط التعاقب",
 "حوكمة العائلة",
 ],
 services: {
 overline: "ما الذي نبنيه",
 title1: "خدمات المكاتب العائلية",
 title2: "للعائلات ذات الثروات الكبيرة",
 desc: "سواء كنتم توازنون بين مكتب عائلي فردي ومكتب عائلي متعدد، أو تعيدون هيكلة مكتب قائم، فإننا نصمم الكيان والحوكمة والفريق حول تفويض عائلتكم.",
 items: [
 { title: "تأسيس المكتب العائلي الفردي", desc: "تأسيس شامل للمكاتب العائلية الفردية للعائلات التي تمتلك أصولًا استثمارية تتجاوز 50 مليون دولار, تأسيس الكيان، والترخيص، والتوظيف، وتصميم سياسة الاستثمار في الولاية القضائية التي تختارونها." },
 { title: "استشارات المكاتب العائلية المتعددة", desc: "وصول فعّال من حيث التكلفة إلى إدارة مؤسسية عالية المستوى دون تحمّل تكاليف تشغيلية سنوية تتجاوز مليون دولار لمكتب مخصص." },
 { title: "حوكمة العائلة", desc: "دساتير عائلية ولجان استثمار وأطر لاتخاذ القرار تحافظ على انسجام ثلاثة أجيال." },
 { title: "تخطيط التعاقب", desc: "هيكلة التركات عبر الحدود، وصناديق ائتمان ومؤسسات مصممة لانتقال سلس للثروة بين الأجيال." },
 { title: "هيكلة الثروات", desc: "هياكل قابضة فعّالة ضريبيًا عبر أنظمة مركز دبي المالي العالمي وسويسرا وسنغافورة, متوافقة تمامًا وخاصة تمامًا." },
 { title: "المخاطر والامتثال", desc: "الملفات التنظيمية، وتراخيص CMS، وتدقيق الأمن السيبراني، والامتثال المستمر للمكاتب العائلية العاملة." },
 ],
 },
 jurisdictions: {
 overline: "أين نعمل",
 title1: "أربع ولايات قضائية.",
 title2: "معيار واحد من السرية.",
 guideLabel: "اقرأ الدليل الكامل",
 items: [
 { name: "دبي · مركز دبي المالي العالمي", points: ["0% ضريبة دخل شخصي", "لوائح الترتيبات العائلية في DIFC", "التأسيس خلال 8-12 أسبوعًا"] },
 { name: "سويسرا", points: ["استقرار سياسي ونقدي", "إرث عريق في الخدمات المصرفية الخاصة", "قانون ائتمان متعدد الأجيال"] },
 { name: "سنغافورة", points: ["إعفاءات MAS للمكاتب العائلية (13O/13U)", "بوابة إلى الأسواق الآسيوية", "تراخيص CMS للمكاتب المتعددة"] },
 { name: "المملكة المتحدة", points: ["وصول عميق إلى أسواق رأس المال", "أطر ائتمانية راسخة", "مواهب استشارية عالمية المستوى"] },
 ],
 },
 process: {
 overline: "منهجية العمل",
 title: "من التفويض إلى مكتب عامل خلال 2-6 أشهر",
 desc: "مسار منضبط قائم على مراحل واضحة. تعرفون دائمًا الخطوة التالية، ومن المسؤول، وما التكلفة.",
 steps: [
 { n: "01", title: "الاستكشاف والتفويض", desc: "تقييم سري للأصول وأهداف العائلة وقرار الاختيار بين المكتب الفردي والمتعدد. عادةً أسبوعان.", time: "الأسبوعان 1-2" },
 { n: "02", title: "الهيكلة واختيار الولاية القضائية", desc: "تصميم الكيان واختيار الولاية القضائية والنمذجة الضريبية عبر DIFC وسويسرا وسنغافورة أو الهياكل المزدوجة.", time: "الأسابيع 3-6" },
 { n: "03", title: "الترخيص والتأسيس", desc: "الملفات التنظيمية، وترخيص المكتب العائلي في DIFC أو إخطارات MAS، والعلاقات المصرفية وخدمات الحفظ.", time: "الأسابيع 7-16" },
 { n: "04", title: "الحوكمة والتسليم", desc: "الدستور العائلي وبيان سياسة الاستثمار والتعيينات الرئيسية والتسليم التشغيلي لمكتبكم.", time: "الأسابيع 17-24" },
 ],
 },
 faq: {
 overline: "رؤى ومعارف",
 title: "أسئلة تطرحها علينا العائلات الثرية",
 items: [
 { q: "كم تبلغ تكلفة تأسيس مكتب عائلي؟", a: "تختلف التكاليف حسب الولاية القضائية والهيكل. يتطلب المكتب العائلي في DIFC نحو 8,000 دولار رسوم طلب و12,000 دولار رسوم ترخيص سنوية، إضافة إلى الأتعاب القانونية والضريبية وخدمات الشركات. أما المكتب العائلي الفردي بكامل موظفيه فتتجاوز تكاليفه التشغيلية عادةً مليون دولار سنويًا, ولهذا تختار العائلات التي تقل أصولها عن 50-250 مليون دولار المكتب العائلي المتعدد غالبًا." },
 { q: "ما الفرق بين المكتب العائلي الفردي والمكتب العائلي المتعدد؟", a: "المكتب العائلي الفردي (SFO) يخدم عائلة واحدة حصريًا, سيطرة كاملة وفريق مخصص وخصوصية تامة، لكن بتكلفة أعلى. المكتب العائلي المتعدد (MFO) يجمع البنية التحتية بين عدة عائلات، ويقدم خبرة مؤسسية بجزء من التكلفة. في سنغافورة، تُعفى المكاتب الفردية عمومًا من ترخيص CMS بينما تتطلبه المكاتب المتعددة؛ وفي DIFC يتطلب كلاهما ترخيصًا محددًا." },
 { q: "ما حجم الثروة اللازم لتبرير مكتب عائلي فردي؟", a: "يحدد معظم المستشارين العتبة بين 50 و250 مليون دولار من الأصول الاستثمارية. دون ذلك، تفوق التكاليف الثابتة للموظفين والامتثال والبنية التحتية عادةً المنافع، ويكون المكتب المتعدد أو المكتب الافتراضي أكثر كفاءة." },
 { q: "لماذا تأسيس مكتب عائلي في دبي (DIFC)؟", a: "يوفر مركز دبي المالي العالمي 0% ضريبة دخل شخصي، وإطارًا قانونيًا مستندًا إلى القانون العام، ولوائح الترتيبات العائلية المخصصة، وقربًا من ثروات دول الخليج. يكتمل التأسيس عادةً خلال 8-12 أسبوعًا، مما يجعله من أسرع الولايات القضائية المتميزة للعائلات الثرية." },
 { q: "كم تستغرق عملية تأسيس المكتب العائلي؟", a: "عادةً 2-6 أشهر من البداية إلى النهاية: الاستكشاف والتفويض (أسبوعان)، والهيكلة واختيار الولاية القضائية (4 أسابيع)، والترخيص والتأسيس (6-10 أسابيع)، ثم الحوكمة والتسليم التشغيلي." },
 { q: "هل تساعدون في تخطيط التعاقب وحوكمة العائلة؟", a: "نعم. نصيغ الدساتير العائلية، وننشئ صناديق الائتمان والمؤسسات، ونصمم لجان الاستثمار، ونضع أطر التعاقب لينتقل كل من الثروة وصنع القرار بسلاسة عبر الأجيال." },
 ],
 },
 form: {
 overline: "استشارة خاصة",
 title: "لنبدأ الحوار.",
 desc: "تبدأ كل شراكة بمحادثة سرية غير ملزمة مع شريك أول. نرد خلال 24 ساعة، وكل ما تشاركونه محمي بسرية تامة.",
 email: "enquiries@aureliusfamilyoffice.com",
 phone: "+971 4 000 0000 · +41 44 000 0000",
 steps: ["تفويضكم", "معلوماتكم", "أهدافكم"],
 labels: {
 service: "الخدمة المطلوبة *",
 jurisdiction: "الولاية القضائية المفضلة *",
 networth: "الأصول الاستثمارية *",
 name: "الاسم الكامل *",
 email: "البريد الإلكتروني *",
 phone: "الهاتف (اختياري)",
 company: "الكيان العائلي / الشركة (اختياري)",
 contactTime: "وقت التواصل المفضل (اختياري)",
 message: "حدثونا باختصار عن أهدافكم (اختياري)",
 },
 options: {
 services: [
 { v: "Single Family Office Setup", l: "تأسيس مكتب عائلي فردي" },
 { v: "Multi-Family Office Advisory", l: "استشارات المكاتب العائلية المتعددة" },
 { v: "Family Governance", l: "حوكمة العائلة" },
 { v: "Succession Planning", l: "تخطيط التعاقب" },
 { v: "Wealth Structuring", l: "هيكلة الثروات" },
 { v: "Undecided", l: "غير محدد, أرشدوني" },
 ],
 jurisdictions: [
 { v: "Dubai (DIFC)", l: "دبي (مركز دبي المالي العالمي)" },
 { v: "Switzerland", l: "سويسرا" },
 { v: "Singapore", l: "سنغافورة" },
 { v: "London", l: "لندن" },
 { v: "United States", l: "الولايات المتحدة" },
 { v: "Undecided", l: "غير محدد, أرشدوني" },
 ],
 networth: [
 { v: "$10M, $50M", l: "10-50 مليون دولار" },
 { v: "$50M, $250M", l: "50-250 مليون دولار" },
 { v: "$250M+", l: "أكثر من 250 مليون دولار" },
 { v: "Prefer not to say", l: "أفضّل عدم الإفصاح" },
 ],
 contactTimes: [
 { v: "Morning", l: "صباحًا" },
 { v: "Afternoon", l: "ظهرًا" },
 { v: "Evening", l: "مساءً" },
 ],
 },
 reviewTitle: "طلبكم",
 next: "متابعة",
 back: "رجوع",
 submit: "اطلب استشارة خاصة",
 submitting: "جارٍ الإرسال...",
 success: "تم استلام طلبكم. سيتواصل معكم شريك أول خلال 24 ساعة.",
 error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
 validation: "يرجى إكمال جميع الحقول المطلوبة.",
 invalidEmail: "يرجى إدخال بريد إلكتروني صحيح.",
 },
 footer: {
 about: "تأسيس المكاتب العائلية والاستشارات للعائلات ذات الثروات الكبيرة في دبي (DIFC) وسويسرا وسنغافورة ولندن والولايات المتحدة.",
 offices: "المكاتب",
 officesList: ["مركز دبي المالي العالمي، جيت فيليج, دبي", "بانهوفشتراسه, زيورخ", "رافلز بليس, سنغافورة"],
 contact: "التواصل",
 guides: "أدلة الولايات القضائية",
 guidesList: [
 { slug: "family-office-dubai-difc", label: "المكتب العائلي في دبي (DIFC)" },
 { slug: "family-office-switzerland", label: "المكتب العائلي في سويسرا" },
 { slug: "family-office-singapore", label: "المكتب العائلي في سنغافورة" },
 { slug: "family-office-london", label: "المكتب العائلي في لندن" },
 { slug: "family-office-usa", label: "المكتب العائلي في الولايات المتحدة" },
 ],
 disclaimer: "أوريليوس فاميلي أوفيس علامة تجارية توضيحية. لا شيء في هذه الصفحة يشكل نصيحة مالية أو قانونية أو ضريبية.",
 },
 },
};
